import React from "react";
import { Row, Col } from "react-bootstrap";
import CompanyDetails from "./CompanyDetails";

const ProfileTab = ({ companyData, current, permanent }) => {
  const registrationData = {
    "Company Registration": companyData?.company_registration_number,
    GST: companyData?.gst_number,
    PAN: companyData?.pan,
    CIN: companyData?.cin,
    TAN: companyData?.tan,
    LLP: companyData?.llp,
  };

  const currentAddress = {
    Address: current?.address,
    City: current?.city,
    State: current?.state,
    Pincode: current?.pincode,
    Country: current?.country,
  };

  const permanentAddress = {
    Address: permanent?.address,
    City: permanent?.city,
    State: permanent?.state,
    Pincode: permanent?.pincode,
    Country: permanent?.country,
  };

  const registrationTooltips = {
    "Company Registration": "Company Registration Number",
    GST: "Goods and Services Tax Number",
    PAN: "Permanent Account Number",
    CIN: "Corporate Identification Number",
    TAN: "Tax Deduction and Collection Account Number",
    LLP: "Limited Liability Partnership ID",
  };
  return (
    <>
      <Row className="mb-3">
        <Col md={6} className="mb-4 mb-md-0">
          <CompanyDetails
            title="Registration Details"
            data={registrationData}
            tooltips={registrationTooltips}
          />
        </Col>
        <Col md={6}>
          <CompanyDetails title="Current Address" data={currentAddress} />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <CompanyDetails title="Permanent Address" data={permanentAddress} />
        </Col>
      </Row>
    </>
  );
};

export default ProfileTab;
